import React from 'react';
import { Card, CardContent, CardHeader } from '@mui/material';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { CARD_HEIGHT_DASHBOARD, PROJECT_COLOR } from '../../../../shared/constants';
import {  useEvent } from '@cobuildlab/react-simple-state';
import es from 'apexcharts/dist/locales/es.json';
import { useStylesCustom } from '../DashboardCardItem';
import { fetchUserByProviderEvents } from '../../../user/user-events';

export const DashboardUserProviderBar: React.FC = () => {
  const classes = useStylesCustom();
  const data = useEvent(fetchUserByProviderEvents);

  const categories = ['GOOGLE', 'SYSTEM', 'FACEBOOK', 'APPLE'];

  const providers = data.filter((d) => !d.primary);

  const DATA: {
    options: ApexOptions;
    series: ApexOptions['series'];
  } = {
    series: [
      {
        name: 'Total',
        data: categories.map((category) => {
          const item = providers.find(
            (provider) => category === provider.provider,
          );

          if (item) return item?.count || 0;

          return 0;
        }),
      },
    ],
    options: {
      colors: [PROJECT_COLOR, PROJECT_COLOR],
      chart: {
        id: 'user-registered-chart',
        height: 300,
        type: 'bar',
        defaultLocale: 'es',
        locales: [es],
      },
      plotOptions: {
        bar: {
          // borderRadius: 10,
          dataLabels: {
            position: 'top', // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function(val: string) {
          return val.toLocaleString();
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#304758'],
        },
      },

      xaxis: {
        categories: categories.map((category) => {
          if (category === 'GOOGLE_ONE_TAB') return 'GOOGLE ONE TAB';

          return category;
        }),
        position: 'bottom',
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        crosshairs: {
          fill: {
            type: 'gradient',
            gradient: {
              colorFrom: '#D8E3F0',
              colorTo: '#BED1E6',
              stops: [0, 100],
              opacityFrom: 0.4,
              opacityTo: 0.5,
            },
          },
        },
        tooltip: {
          enabled: true,
        },
      },
      yaxis: {
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show: false,
          formatter: function(val: number) {
            return val.toLocaleString();
          },
        },
      },
    },
  };

  return (
    <Card
      elevation={2}
      style={{
        border: '1px solid #BBBBBB',
        padding: '16px',
        borderRadius: '16px',
        boxShadow: '0px 0px 8px 0px #00000014',
      }}
    >
      <CardHeader
        classes={{
          title: classes.title,
        }}
        className={classes.header}
        title="Cuentas conectadas por canal"
      />

      <CardContent
        className={classes.content}
        style={{ height: CARD_HEIGHT_DASHBOARD }}
      >
        {(DATA.series?.length ?? 0) > 0 ? (
          <Chart
            options={DATA.options}
            series={DATA.series}
            type="bar"
            height={'100%'}
          />
        ) : null}
      </CardContent>
    </Card>
  );
};
